import {Card, SimpleGrid, Text, Title, Anchor, Group, ThemeIcon} from "@mantine/core"
import {
  IconMap,
  IconPassword,
  IconTextSize,
  IconRulerMeasure,
  IconExternalLink, IconCoin,
} from "@tabler/icons-react"

const tools = [
  {
    name: "Map Printer",
    description: "Select a map area, configure grid and export to PDF for printing.",
    icon: IconMap,
    color: "blue",
    href: "/tools/map-printer.html",
  },
  {
    name: "Password Generator",
    description: "Generate random secure passwords with custom length and options.",
    icon: IconPassword,
    color: "teal",
    href: "/tools/password-generator.html",
  },
  {
    name: "Plan Measure",
    description: "Upload a floor plan, set a reference line and measure distances and areas.",
    icon: IconRulerMeasure,
    color: "yellow",
    href: "/tools/plan-measure.html",
  },
  {
    name: "Lorem Ipsum",
    description: "Generate placeholder text for your designs and mockups.",
    icon: IconTextSize,
    color: "orange",
    href: "/tools/lorem-ipsum.html",
  },
  {
    name: "Flat plan",
    description: "Draw a flat plan",
    icon: IconRulerMeasure,
    color: "orange",
    href: "/tools/plan.html",
  },
  {
    name: "Car price",
    description: "Calculate route price",
    icon: IconCoin,
    color: "orange",
    href: "/tools/car.html",
  },
]

const Mix = () => {
  return (
    <>
      <Title order={3} mb="md">Mix tools</Title>
      <Text c="dimmed" mb="xl">Standalone mini-tools — each opens in a new tab.</Text>

      <SimpleGrid cols={{base: 1, sm: 2, md: 3}} spacing="lg">
        {tools.map((tool) => (
          <Anchor
            key={tool.name}
            href={tool.href}
            target="_blank"
            underline="never"
          >
            <Card shadow="sm" padding="lg" radius="md" withBorder h="100%" style={{cursor: "pointer"}}>
              <Group mb="sm">
                <ThemeIcon variant="light" size="lg" color={tool.color}>
                  <tool.icon size={20}/>
                </ThemeIcon>
                <Title order={4}>{tool.name}</Title>
                <IconExternalLink size={14} opacity={0.4}/>
              </Group>
              <Text size="sm" c="dimmed">{tool.description}</Text>
            </Card>
          </Anchor>
        ))}
      </SimpleGrid>
    </>
  )
}

export default Mix
